import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { ContextMenuModule } from 'ngx-contextmenu';
import { CommonComponentsModule } from '../common-components/common-components.module';

import { Routes, Router, RouterModule } from '@angular/router';

import * as fromModules from '../modules';
import * as fromContainers from './containers';
import * as fromComponents from './components';
import * as fromDialogs from './dialogs';
import { ServicesModule } from '../services/services.module';

const routes: Routes = [
  { path: 'matches', component: fromContainers.MatchListComponent },
  { path: 'matches/:id', component: fromContainers.MatchEditorComponent }
];

@NgModule({
  declarations: [
    ...fromContainers.containers,
    ...fromComponents.components,
    ...fromDialogs.dialogs
  ],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    RouterModule.forChild(routes),
    ContextMenuModule,
    CommonComponentsModule,
    ...fromModules.modules,
    ServicesModule
  ],
  providers: [],
  entryComponents: [...fromDialogs.dialogs]
})
export class MatchModule {}
